module.exports = __webpack_public_path__ + "img/landing-graphic-2.4cfd492b.svg";